// extracted by mini-css-extract-plugin
export default {"employee":"employee_employee__Fiug+","name":"employee_name__xIJct","phone":"employee_phone__Tkrcd","login":"employee_login__UVv5P","actions":"employee_actions__Z4euo"};